export default __webpack_public_path__ + "static/media/online-training.38e8cfa5.jpg";